import Inspiration from './inspiration';
export default Inspiration;